import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100 rounded-full mb-4">
            Kategorie produktów
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Przeglądaj Kakobuy Spreadsheet według kategorii
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Wybierz kategorię i znajdź najlepsze produkty w Kakobuy. Wszystkie linki prowadzą bezpośrednio do aktualnych list produktów.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-xl border border-background-200/50 hover:border-primary-300 hover:shadow-md overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-background-200">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex flex-col items-center gap-1.5">
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 text-center leading-tight transition-colors">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 text-center leading-tight hidden sm:block">
                  {cat.description}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}